<template>
  <div v-click-outside="$_subNavClose" class="nav-drawer-wrap">
    <div class="nav-drawer" :class="{ subActive: isActive.subList }">
      <div class="nav-drawer-fixed-header">
        <div class="logo-block">
          <img :src="soloLogo" class="solo-logo" />
          <img :src="logo" class="logo" />
        </div>
        <LvDropdownMenuMultiLayer
          v-model="factoryDropdownMenu.selectedMenuItem"
          :outline="false"
          :isShrink="_isShrink"
          :items="_dropdownItems"
          :icon="'icon-arrow-drop-up-circle'"
          :minWidth="_isShrink ? '46px' : '200px'"
          class="mt-28"
          @click="$_onClickDropdown($event)"
        />
      </div>
      <perfect-scrollbar class="nav-drawer-content ps">
        <div class="nav-drawer-list">
          <NavDrawerListItem
            v-for="(item, itemIndex) in _facNavDrawerListItems"
            :key="itemIndex"
            :listItem="item"
            :isDisabled="item.disabled"
            :subActive="isActive.subList"
            :to="$_getRouterLink(item.link)"
            :activiated="$_getActiveByIngViewName(item)"
            @click="$_onClickItem(item)"
          />
        </div>
      </perfect-scrollbar>
      <div v-if="_isSosAvailable" class="nav-drawer-fixed-footer">
        <ProminentButton
          leadingIcon="icon-SOS"
          color="red"
          link="emergency"
          iconGradient="red"
          textLabel="緊急求助"
          :subActive="isActive.subList"
          @click="$_onOpenSos()"
        />
      </div>
    </div>
    <SubNavDrawer ref="subNav" title="管理" :menuItems="ingSubNavDrawer" @click="$_subNavClose()" />
    <PopUp
      notice
      title="您無此單位內相關權限，請聯絡系統管理員"
      :popUpActive="isActive.scopePopup"
      @click="$_onClosePopup('scopePopup')"
    >
      <LlCancelPopupContent>
        <template v-slot:buttons>
          <WsButton001 @click="$_onClosePopup('scopePopup')">
            {{ $t('知道了') }}
          </WsButton001>
        </template>
      </LlCancelPopupContent>
    </PopUp>
  </div>
</template>

<script>
import ClickOutside from 'vue-click-outside';
import config from '@/__config';
import S_init from '@/service/api/v1/init';
import S_scope from '@/service/api/v1/scope';
import Spare_common from '@/spare/common';
import Spare_navDrawer from '@/spare/navDrawer';

export default {
  directives: {
    ClickOutside,
  },
  data() {
    return {
      isActive: {
        subList: false,
        scopePopup: false,
      },
      logo: require('@/assets/image/logo-horizontal.svg'),
      soloLogo: require('@/assets/image/logo-solo.svg'),
      window: {
        width: 0,
        height: 0,
      },
      factoryDropdownMenu: {
        selectedMenuItem: null,
      },
      navDrawerListItems: [],
      ingSubNavDrawer: [],
      allFactories: [],
    };
  },
  computed: {
    _currentUser() {
      return this.$store.state.stone_auth.currentUser;
    },
    _currentFactoryId() {
      return this.$route.params.factoryId;
    },
    _currentOrganizationId() {
      return this.$route.params.organizationId;
    },
    _dropdownItems() {
      if (!this._currentUser) return [];
      const allFactory = this._currentUser.factories;
      const dropdownItems = this.$_getDropdownItems(allFactory);
      return dropdownItems;
    },
    _subscriptionMap() {
      const factory = this.$store.state.app.factory;
      if (!factory || !factory.subscriptions) return {};
      return Object.fromEntries(factory.subscriptions.map(subscription => [subscription, true]));
    },
    _ingViewName() {
      if (!this.$route.meta.name) return;
      return this.$route.meta.name;
    },
    _facNavDrawerListItems() {
      const subscriptionMap = Spare_common.getSubscriptionMap();
      const subListSubscriptionMap = Spare_common.subListSubscriptionMap;
      const allListItems = Spare_navDrawer.getDrawerItems();
      const listItems = allListItems
        .map(item => {
          const itemId = item.id;
          if (item.hasSubItems) {
            const requiredSub = subListSubscriptionMap[itemId];
            if (!requiredSub) return item;
            let hasSubItems = false;
            for (const subItemId in requiredSub) {
              const requiredSubKey = requiredSub[subItemId];
              if (this._subscriptionMap[requiredSubKey]) {
                hasSubItems = true;
                break;
              }
            }
            if (!hasSubItems) return null;
            const filteredSubList =
              item.subList &&
              item.subList.filter(subItem => {
                const requiredSubKey = requiredSub[subItem.id];
                return !requiredSubKey || this._subscriptionMap[requiredSubKey];
              });
            return {
              ...item,
              subList: filteredSubList,
            };
          } else {
            const requiredSubKey = subscriptionMap[itemId];
            if (!requiredSubKey || this._subscriptionMap[requiredSubKey]) {
              return item;
            }
            return null;
          }
        })
        .filter(item => item !== null)
        // 客戶包只顯示有打包的模組；線上包 isModuleEnabled 恆為 true，不會濾掉任何項目
        .filter(item => config.build.isModuleEnabled(item.module))
        .map(item => {
          if (!Array.isArray(item.subList)) return item;
          return {
            ...item,
            subList: item.subList.filter(subItem => config.build.isModuleEnabled(subItem.module)),
          };
        })
        .filter(item => !Array.isArray(item.subList) || item.subList.length > 0);
      if (this._isAllianceHomePage && config.build.isModuleEnabled('alliance')) {
        listItems.unshift({
          id: 'alliance',
          textLabel: '首頁',
          leadingIcon: 'icon-ll-esgoal-accommodation',
          activiatedLeadingIcon: 'icon-ll-esgoal-accommodation',
          activiated: false,
          link: '/alliances',
        });
      }
      return listItems;
    },
    _isAllianceHomePage() {
      return this.$store.state.app.factory.isAllianceHomePage;
    },
    _isShrink() {
      return this.isActive.subList || this.window.width <= 1199;
    },
    _isSosAvailable() {
      return config.build.esgoalContact && S_scope.$_isAvailable(['sos-create']);
    },
  },
  watch: {
    _currentFactoryId() {
      this.$_getDropdownInit();
    },
    _currentOrganizationId() {
      this.$_getDropdownInit();
    },
  },
  mounted() {
    this.$_handleResize();
    this.$_getDropdownInit();
  },
  created() {
    window.addEventListener('resize', this.$_handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.$_handleResize);
  },
  methods: {
    $_getDropdownInit() {
      if (this._currentFactoryId)
        this.factoryDropdownMenu.selectedMenuItem = this._currentFactoryId;
      const allFactories = S_init.getUserJoinedFactoryList(this._currentUser.factories);
      this.allFactories = new Map(allFactories.map(factory => [factory.id, factory]));
    },
    $_getRouterLink(link) {
      if (this._currentFactoryId) return `/factory/${this._currentFactoryId}${link}`;
      else if (this._currentOrganizationId)
        return `/organization/${this._currentOrganizationId}${link}`;
    },
    $_getDropdownItems(factories) {
      const dropdownItems = [];
      factories.forEach(factory => {
        const { id, name, child_factories, is_alliance_home_page } = factory;
        const item = {
          id,
          name,
          isAllianceHomePage: is_alliance_home_page,
          items: child_factories ? this.$_getDropdownItems(child_factories) : [],
        };
        dropdownItems.push(item);
      });
      const sortDropdownItems = dropdownItems.sort(function (a, b) {
        return a.id < b.id ? -1 : 1;
      });
      return sortDropdownItems;
    },
    async $_onClickDropdown($event) {
      const factoryId = $event;
      if (S_scope.isFactoryAvailable(factoryId)) {
        const factory = this.allFactories.get(factoryId);
        const isAllianceHomePage = factory.is_alliance_home_page;
        await this.$_changeFactory(factoryId);
        const path = isAllianceHomePage ? 'alliances' : 'board-overview';
        this.$router.push(`/factory/${factoryId}/${path}`);
      } else this.$_onOpenPopup('scopePopup');
    },
    async $_changeFactory(factoryId) {
      localStorage.setItem('factoryId', factoryId);
      this.$store.dispatch('app/setFactoryId', factoryId);
      const factory = this.$store.state.app.factory;
      this.$store.dispatch('app/setFactory', {
        ...factory,
        id: factoryId,
      });
      this.$store.dispatch('stone_app/setMounted', false);
    },
    $_deleteAttach($event) {
      this.sosData.attaches.splice($event, 1);
    },
    $_handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
    $_onClickItem(item) {
      this.$_subNavClose();
      const originButtons = this.navDrawerListItems;
      originButtons.forEach(originOverallItem => {
        originOverallItem.activiated = false;
      });
      item.activiated = true;
      if (item.subList) {
        this.ingSubNavDrawer = item.subList;
        this.isActive.subList = true;
        this.$refs.subNav.$_slideOpen();
      } else this.$refs.subNav.slideActive = false;
    },
    $_subNavClose() {
      this.isActive.subList = false;
      this.$refs.subNav.slideActive = false;
    },
    $_getActiveByIngViewName(item) {
      if (!this._ingViewName) return;
      const subList = item.subList || [];
      const isSubItemActive = subList.some(subItem => this._ingViewName.includes(subItem.id));
      return (
        this._ingViewName === item.id ||
        (this._ingViewName.indexOf('management') > -1 && item.id === 'management') ||
        (this._ingViewName.indexOf('setting') > -1 && item.id === 'setting') ||
        isSubItemActive
      );
    },
    $_onOpenSos() {
      if (S_scope.$_isAvailable(['sos-create']))
        this.$store.dispatch('sospopup/openSosPopup', { contactFor: 1 });
      else this.$store.dispatch('invalidpopup/openInvalidPopup');
    },
    $_onOpenPopup(type) {
      this.isActive[type] = true;
    },
    $_onClosePopup(type) {
      this.isActive[type] = false;
    },
  },
};
</script>

<style lang='scss'>
@import '@/assets/scss/component/nav-drawer';
</style>
